import AbstractView from "abstracts/AbstractView";
import Main from "controllers/Main";
import Screen from "controllers/Screen";
import * as PIXI from 'lib/pixi.js'
import Scroll from "controllers/Scroll";
import Math_ from "utils/Math";


export default class AbstractHeader extends AbstractView {
	constructor($wrapper) {
		super();
		this.$wrapper = $wrapper;
		this.DEG_TO_RAD = Math.PI / 180;
		this.shapesResolution = 1;
		this.shapes = [];
		this.introAlpha = 1;
		this.pxShape = null;
		// this.resolution = Math_.clamp(window.devicePixelRatio, 1, 2);
		this.resolution = 1;
		this.realHeight = Screen.wH;
		this.virtualHeight = this.realHeight * 2;
		this.isVisible = true;
		this.scrollPercent = 0;

		// PIXI Graphics configuration
		PIXI.GRAPHICS_CURVES.maxLength = 1024;
		PIXI.GRAPHICS_CURVES.maxSegments = 10;
		PIXI.GRAPHICS_CURVES.minSegments = 6;
		// PIXI.GRAPHICS_CURVES.epsilon = 1;
	}

	init() {
		if (navigator.userAgent.indexOf('Speed Insights') > -1 || navigator.userAgent.indexOf('Chrome-Lighthouse') > -1) {
			return;
		}
		super.init();
		this.intro();
	}


	initEl() {
		// APP
		this.app = new PIXI.Application({
			resizeTo: this.$wrapper[0],
			resolution: this.resolution,
			antialias: true,
			backgroundColor: '0x202020',
			sharedTicker: false,
			sharedLoader: true
		});
		this.$wrapper.append(this.app.view);
		this.app.stage.interactive = false;
		this.app.stage.interactiveChildren = false;
		this.pxShape = new PIXI.Container();
		this.app.stage.addChild(this.pxShape);
	}


	bindEvents() {
		Main.on(Main.E.RAF, this.raf, this);
		Screen.on(Screen.E.RESIZE, this.resize, this);
	}


	unbindEvents() {
		Main.off(Main.E.RAF, this.raf, this);
		Screen.off(Screen.E.RESIZE, this.resize, this);
		super.unbindEvents();
	}

	raf() {
		this.checkScroll();
		if (this.isVisible) {
			this.scrollPercent = Math.min(1, Scroll.yI / this.virtualHeight);
		}
	}

	checkScroll() {
		if (Scroll.yI > this.virtualHeight && this.isVisible === true) {
			this.scrollPercent = 1;
			this.isVisible = false;
			this.pause();
		} else if (Scroll.yI <= this.virtualHeight && this.isVisible === false) {
			this.isVisible = true;
			this.resume();
		}
	}


	resize(isMobileH) {

		if (isMobileH) {
			return;
		}

		this.realHeight = this.$wrapper.height();
		this.virtualHeight = this.realHeight * 1.5;

		// Updates the shapes
		this.drawShapes();
	}


	intro() {
		gsap.from(this, {
			duration: 2,
			delay: 1.2,
			introAlpha: 0
		});
	}


	killShapes() {
		// Kill shapes
		if (this.shapes.length) {
			while (this.shapes.length) {
				let shape = this.shapes[this.shapes.length - 1];
				this.killShape(shape);
			}
			this.shapes = [];
		}
	}

	pause() {
		this.app.stop();
	}

	resume() {
		this.app.start();
	}


	destroy() {
		this.killShapes();
		this.app.destroy(true);
		super.destroy();
	}

}
